@import "~animatewithsass/animate.scss";

@mixin content {
  .title {
    font-size:20px;
    @media (min-width: 768px) and (max-width: 1100px) {
      font-size: 16px !important;
    }
    font-weight: 100;
    padding-bottom:5px;
  }
}

.stage-block {
  @include content;
  display: flex;
  align-items: center;
}

.output1-row {
  .output1-row-block {
    border-radius: 10px;
    .scaleable-true{
      height:auto;
      max-height: 600px !important;
      opacity:1;
      //-webkit-transition: max-height 3s ease;
      transition: max-height 2s ease,opacity 2s ease;
      overflow: hidden;
     /* @include fadeInDown(
              $duration: 1s,
              $delay: 0.5s,
              $function: ease-out
      )*/
    }
    .scaleable-false{
      height:auto;
      max-height: 0 !important;
      opacity:0;
    //-webkit-transition: max-height 2s ease;
      transition: max-height 1s ease,opacity 2s ease;
      overflow: hidden;
      /*@include fadeOutUp(
              $duration: 1s,
              $delay: 0s,
              $function: ease-out);*/
    }
    .text {
      font-weight: lighter;
      padding-bottom: 8px;
      letter-spacing: 1px;
    }
    .switch-component {
    }
    .scaleable {
      @include content
    }
    .grinder {
      font-size: 24px;
      font-weight: lighter;
    }
    @media (max-width: 767px) {
      .mobile-padding{
        padding-top: 0 !important;
      }
      .p-l-15{
        padding-left: 15px !important;
      }
    }
    .content {
      .minimum {
        display: table;
        @include content;
      }
      .start-time {
        display: table;
        @include content;
      }
      .maximum {
        display: table;
        margin: 0 0 0 auto;
        @include content;
      }
      .run-time{
        display: table;
        margin: 0 0 0 auto;
        @include content;
      }
    }
    .divider {
      hr {
      }
    }
  }
}


// WEBPACK FOOTER //
// webpack:///var/jenkins_home/workspace/azure-dev-vm-baristadj/src/app/components/recipe/editor/output1/output1.scss